module.exports = __webpack_public_path__ + "img/huntica-rt.ddc7b5d0.svg";